module.exports = __webpack_public_path__ + "img/download-3-panel-4.9b8af700.png";